export const classes = [
  {
    name: 'Guardião Protetor',
    slug: 'guardiao_protetor',
    primary: 'str',
    secondary: 'wis',
    pv: [18, 3],
    ph: 6,
    str: 10,
    res: [10, 2],
    dex: 6,
    agi: 6,
    wis: 8,
    int: [8, 2],
    skills: [
      {
        name: 'Lançar Escudo',
        cost: 1,
        type: 'def',
        desc:
          'Pode ser ativada quando um personagem que esteja até 3 quadrados de distância estiver sendo atacado. Defesa + 3 para o alvo.'
      },

      {
        name: 'Resistir',
        cost: 2,
        type: 'def',
        desc:
          'Pode ser ativada quando esse personagem estiver sendo atacado. Dano - 1 por 1 rodada e Mov + 1 no próximo turno desse personagem.'
      },

      {
        name: 'Protetor Leal',
        cost: 2,
        type: 'def',
        desc:
          'Pode ser ativada quando um personagem que esteja até 3 quadrados de distância estiver sendo atacado. Troca de lugar com o aliado. Dano - 2 por 1 rodada.'
      },

      {
        name: 'Escudo Refletor',
        cost: 2,
        type: 'def',
        desc:
          'Pode ser ativada quando este personagem estiver sendo atacado. Dano sofrido é reduzido em 50% arredondado para baixo. Causa uma quantidade de dano igual à sofrida ao atacante.'
      }
    ]
  },

  {
    name: 'Ninja',
    slug: 'ninja',
    primary: 'dex',
    secondary: 'wis',
    pv: 12,
    ph: 6,
    str: 6,
    res: 6,
    dex: 10,
    agi: [10, 2],
    wis: 8,
    int: [8, 2],
    skills: [
      {
        name: 'Dança das Kunais',
        cost: 1,
        type: 'atk',
        desc:
          'Pode ser ativada contra um oponente até 2 quadrados de distância. Joga 1d6: Se resultado for 6: Dano + 3, se o resultado for 5: Dano + 2, se o resultado for 4: Dano + 1.'
      },

      {
        name: 'Bomba de Fumaça',
        cost: 2,
        type: 'def',
        desc:
          'Pode ser ativada quando esse personagem está sendo atacado. Joga 1d6, se o resultado for entre 1 e 5: Dano sofrido - 1, se o resultado for 6: Dano sofrido reduzido em 50% arredondado para cima.'
      },

      {
        name: 'Dança das Sombras',
        cost: 1,
        type: 'atk',
        desc:
          'Dano + 2. Se o horário for “Noite”: Dano + 1, se o clima for “Neblina”: Dano + 1 (Acumulativo).'
      },

      {
        name: 'Chuva de Shurikens',
        cost: 4,
        type: 'atk',
        desc:
          'Pode ser ativada contra um oponente até 2 quadrados de distância. Realiza um ataque adicional.'
      }
    ]
  },

  {
    name: 'Necromante',
    slug: 'necromante',
    primary: 'wis',
    secondary: 'dex',
    pv: 8,
    ph: [8, 2],
    str: 6,
    res: 6,
    dex: [8, 2],
    agi: 8,
    wis: [10, 2],
    int: 10,
    skills: [
      {
        name: 'Invocar Escuridão',
        cost: 2,
        type: 'sup',
        desc:
          'Muda o horário pra “Noite” e o clima pra “Neblina” durante 3 rodadas.'
      },

      {
        name: 'Trocar de Alma',
        cost: 3,
        type: 'sup',
        desc: 'PV - 1, Dano + 3 durante 2 rodadas'
      },

      {
        name: 'Ressureição',
        cost: 'all',
        type: 'sup',
        desc:
          'Ressuscita um personagem morto no campo de batalha sacrificando a própria vida e colocando sua alma dentro do corpo ressuscitado. Joga 1d6, se o resultado for um número par: O personagem ressuscita com PV 100%, se o resultado for um número ímpar o personagem ressuscita com PV 50% arredondado para cima.'
      },

      {
        name: 'Invocação Sombria',
        cost: 'all',
        type: 'sup',
        desc:
          'Gasta todos PHs. Invoca um novo personagem da raça zumbi de nível Aprendiz. Se estiver com a arma lendária Grimório do Submundo o nível se torna “Veterano”, se estiver com o acessório Talismã das Profundezas o nível se torna “Normal”, se estiver com ambos o nível se torna “Lendário”.'
      }
    ]
  },

  {
    name: 'Alquimista',
    slug: 'alquimista',
    primary: 'wis',
    secondary: 'dex',
    pv: [8, 2],
    ph: [8, 2],
    str: 6,
    res: [8, 2],
    dex: 8,
    agi: 6,
    wis: [10, 2],
    int: 10,
    skills: [
      {
        name: 'Poção de Cura',
        cost: 2,
        type: 'sup',
        desc: 'PV + 5 para o próprio personagem ou um personagem adjacente.'
      },

      {
        name: 'Spray Venenoso',
        cost: 2,
        type: 'sup',
        desc:
          'Envenena um personagem até 2 quadrados de distância durante 2 rodadas.'
      },

      {
        name: 'Transmutar Arma/Armadura',
        cost: 2,
        type: 'sup',
        desc:
          'Transforma uma Arma ou Armadura do próprio personagem ou um personagem adjacente em ouro durante 2 rodadas. Dano ou Defesa + 3 e Mov - 1.'
      },

      {
        name: 'Névoa Esmagadora',
        cost: 4,
        type: 'sup',
        desc:
          'Transforma o clima em “Neblina”, Dano e Defesa + 3 e Mov + 2 durante 3 rodadas.'
      }
    ]
  },

  {
    name: 'Monge',
    slug: 'monge',
    primary: 'str',
    secondary: 'wis',
    pv: [12, 2],
    ph: 6,
    str: [10, 2],
    res: 6,
    dex: 6,
    agi: 10,
    wis: [8, 2],
    int: 8,
    skills: [
      {
        name: 'Chute Furacão',
        cost: 2,
        type: 'atk',
        desc: 'Empurra o alvo 2 quadrados para trás e Dano + 1.'
      },

      {
        name: 'Soco Perfurante',
        cost: 2,
        type: 'atk',
        desc:
          'Dano + 1. Joga 1d6, se o resultado for um número par: deixa o alvo sangrando por 2 rodadas, se o resultado for um número ímpar deixa o alvo sangrando por 1 rodada.'
      },

      {
        name: 'Golpe de Titã',
        cost: 2,
        type: 'atk',
        desc:
          'Dano + 3. Joga 1d6, se o resultado for um número par: deixa o alvo desmaiado por duas rodadas, se o resultado for um número ímpar deixa o alvo desmaiado por uma rodada.'
      },

      {
        name: 'Alcançar o Nirvana',
        cost: 'all',
        type: 'sup',
        desc:
          'Fica uma rodada sem fazer ação: recupera todo o PV e Dano e Defesa + 2 durante o restante da batalha.'
      }
    ]
  },

  {
    name: 'Ladino',
    slug: 'ladino',
    primary: 'dex',
    secondary: 'wis',
    pv: 8,
    ph: 6,
    str: 6,
    res: 6,
    dex: [10, 2],
    agi: 10,
    wis: 8,
    int: [8, 2],
    skills: [
      {
        name: 'Ataque Sorrateiro',
        cost: 2,
        type: 'atk',
        desc:
          'Pode ser ativada Apenas se o horário for “Noite”, o clima for “Neblina” ou o terreno for “Floresta”. Dano + 3.'
      },

      {
        name: 'Concentrar na Batalha',
        cost: 1,
        type: 'sup',
        desc: 'Dano e Defesa + 1 durante duas rodadas.'
      },

      {
        name: 'Roubo Épico',
        cost: 3,
        type: 'sup',
        desc:
          'Rouba o Acessório de um personagem. Joga 1d6, se o resultado for 1 ou 6, pode utilizar o Acessório roubado.'
      },

      {
        name: 'Marca do Ladino',
        cost: 'all',
        type: 'atk',
        desc:
          'Pode ser ativada contra um oponente até 3 quadrados de distância. Deixa o oponente sangrando pelo resto da batalha. Se o horário for “Noite” esse personagem pode sacrificar 5 pontos de PV e ficar um turno paralisado para tirar 50% do PV do oponente arredondado para baixo.'
      }
    ]
  },

  {
    name: 'Bardo',
    slug: 'bardo',
    primary: 'wis',
    secondary: 'dex',
    pv: [8, 2],
    ph: [8, 2],
    str: 6,
    res: 6,
    dex: 8,
    agi: [8, 2],
    wis: 10,
    int: [10, 2],
    skills: [
      {
        name: 'Cancão Tribal',
        cost: 2,
        type: 'sup',
        desc: 'Muda o horário e clima randomicamente.'
      },

      {
        name: 'Canção do Desespero',
        cost: 2,
        type: 'sup',
        desc:
          'Pode ser ativada contra um oponente até 3 quadrados de distância. Diminui todos os atributos em 2 pontos durante 2 rodadas.'
      },

      {
        name: 'Canção de Ânimo',
        cost: 2,
        type: 'sup',
        desc:
          'Aumenta todos os atributos de todos aliados (inclusive desse personagem) em 2 pontos por 2 rodadas.'
      },

      {
        name: 'Canção do Inferno e do Paraíso',
        cost: 'all',
        type: 'sup',
        desc:
          'Joga 1d6, se o resultado for um número par: Todos os oponentes ficam paralisados durante 2 rodadas e todos os atributos são diminuídos em 2 pontos permanentemente. Se o resultado for um número ímpar: Todos os aliados (inclusive esse personagem) ganham 2 pontos permanentes em todos atributos e recupera 10 pontos de PV de cada um.'
      }
    ]
  },

  {
    name: 'Mestre Modelador',
    slug: 'mestre_modelador',
    primary: 'wis',
    secondary: 'dex',
    pv: 8,
    ph: [8, 2],
    str: 6,
    res: [8, 2],
    dex: 8,
    agi: 6,
    wis: [10, 2],
    int: 10,
    skills: [
      {
        name: 'Modelar Terreno',
        cost: 2,
        type: 'sup',
        desc:
          'Muda uma área de 3x3 - com o centro sendo esse personagem - para um terreno aleatório.'
      },

      {
        name: 'Controlar Tempo',
        cost: 2,
        type: 'sup',
        desc:
          'Altera o clima ou o horário do campo de batalha para o que quiser durante 2 rodadas.'
      },

      {
        name: 'Transportar para o Vazio',
        cost: 'all',
        type: 'sup',
        desc:
          'Muda todo o terreno, horário e clima do campo de batalha permanentemente (sem poder ser alterado por qualquer outra habilidade) para “Vazio” (Mov - 1 para todos personagens que não sejam Mestre Modelador).'
      },

      {
        name: 'Modelar Universo',
        cost: 'all',
        type: 'sup',
        desc:
          'Muda todo o terreno, horário e clima do campo de batalha permanentemente (sem poder ser alterado por qualquer outra habilidade) para o que quiser.'
      }
    ]
  },

  {
    name: 'Bárbaro',
    slug: 'barbaro',
    primary: 'str',
    secondary: 'dex',
    pv: [18, 3],
    ph: 4,
    str: [10, 2],
    res: 10,
    dex: [8, 2],
    agi: 8,
    wis: 6,
    int: 6,
    skills: [
      {
        name: 'Golpe Selvagem',
        cost: 1,
        type: 'atk',
        desc: 'Dano + 4. Mov - 1 e Defesa - 2 durante 1 rodada.'
      },

      {
        name: 'Grito de Glória',
        cost: 2,
        type: 'sup',
        desc:
          'Pode ser ativado quando um personagem morre. Dano + 7 no próximo ataque desse personagem - não cumulativo com habilidades.'
      },

      {
        name: 'Fúria Cegante',
        cost: 2,
        type: 'atk',
        desc:
          'Dano dobrado. Joga 1d6, se o resultado for 1 ou 2 leva o mesmo dano.'
      },

      {
        name: 'Insanidade Furiosa',
        cost: 'all',
        type: 'sup',
        desc:
          'Sacrifica metade do PV: Dano + 10 e Defesa - 10 durante 3 rodadas.'
      }
    ]
  },

  {
    name: 'Mercenário',
    slug: 'mercenario',
    primary: 'dex',
    secondary: 'str',
    pv: [12, 2],
    ph: 6,
    str: [8, 2],
    res: 6,
    dex: [10, 2],
    agi: 8,
    wis: 6,
    int: 10,
    skills: [
      {
        name: 'Esfaquear',
        cost: 1,
        type: 'atk',
        desc:
          'Dano + 1. Joga 1d6, se o resultado for 5 ou 6 deixa o alvo sangrando por 1 rodada.'
      },

      {
        name: 'Envenenar Lâmina',
        cost: 2,
        type: 'atk',
        desc:
          'Dano + 2. Joga 1d6, se o resultado for 5 ou 6 envenena o alvo por 2 rodadas.'
      },

      {
        name: 'Combo Insano',
        cost: 4,
        type: 'atk',
        desc:
          'Joga 1d6, se o resultado for entre 1 e 5 ganha um ataque adicional e se o resultado for 6 ganha dois ataques adicionais. Dano dos ataques adicionais são reduzidos em 50% arredondado para baixo.'
      },

      {
        name: 'Esfolar',
        cost: 'all',
        type: 'atk',
        desc:
          'Arranca um pedaço da pele do oponente: Dano + 8 e deixa o alvo sangrando pelo restante da batalha.'
      }
    ]
  },

  {
    name: 'Mago',
    slug: 'mago',
    primary: 'wis',
    secondary: 'dex',
    pv: 8,
    ph: [8, 2],
    str: 6,
    res: 6,
    dex: 8,
    agi: [8, 2],
    wis: [10, 2],
    int: 10,
    skills: [
      {
        name: 'Armadura de Raios',
        cost: 2,
        type: 'sup',
        desc:
          'Defesa + 1. Cria uma armadura que dura 2 rodadas. Toda vez que recebe um ataque, o atacante joga 1d6, se o resultado for 1 ou 2 ele fica sem se movimentar por 2 rodadas.'
      },

      {
        name: 'Bola de Ar',
        cost: 3,
        type: 'atk',
        desc:
          'Pode ser ativada contra um oponente até 2 quadrados de distância. Arremessa o alvo 3 quadrados para trás e Dano + 1.'
      },

      {
        name: 'Parede Flamejante',
        cost: 3,
        type: 'sup',
        desc:
          'Cria uma parede que dura 3 rodadas e cerca uma área de 5x5 - com o centro sendo esse personagem - onde qualquer um que passar pela parede recebe 2d6 de dano e fica queimando por 2 rodadas.'
      },

      {
        name: 'Tempestade de Gelo',
        cost: 6,
        type: 'atk',
        desc:
          'Invoca uma tempestade de gelo em uma área de 5x5 - com o centro sendo esse personagem - Dano + 4 e congela todos os personagens nessa área por 1 rodada.'
      }
    ]
  },

  {
    name: 'Caçador',
    slug: 'cacador',
    primary: 'dex',
    secondary: 'wis',
    pv: [12, 2],
    ph: 6,
    str: 6,
    res: 6,
    dex: [10, 2],
    agi: 10,
    wis: 8,
    int: [8, 2],
    skills: [
      {
        name: 'Marca do Caçador',
        cost: 1,
        type: 'atk',
        desc: 'Dano + 1. Defesa - 1 do alvo durante a próxima rodada.'
      },

      {
        name: 'Tiro Firme',
        cost: 1,
        type: 'atk',
        desc: 'Alcance + 1 e Dano + 2.'
      },

      {
        name: 'Seguir Rastros',
        cost: 3,
        type: 'sup',
        desc:
          'Pode ser ativada contra um oponente até 3 quadrados de distância. Marca um alvo. Ao invés de fazer uma ação de movimento, esse personagem pode teletransportar para um quadrado adjacente ao alvo marcado.'
      },

      {
        name: 'Caçada Brutal',
        cost: 1,
        type: 'atk',
        desc:
          'Pode ser ativada contra um oponente até 3 quadrados de distância e que esteja marcado pela habilidade “Seguir Rastros”. Dano + 7.'
      }
    ]
  },

  {
    name: 'Guerreiro',
    slug: 'guerreiro',
    primary: 'str',
    secondary: 'dex',
    pv: [18, 3],
    ph: 6,
    str: [10, 2],
    res: 10,
    dex: [8, 2],
    agi: 6,
    wis: 6,
    int: 8,
    skills: [
      {
        name: 'Corte Preciso',
        cost: 1,
        type: 'atk',
        desc: 'Dano + 1.'
      },

      {
        name: 'Desafiar',
        cost: 1,
        type: 'sup',
        desc:
          'Pode ser ativada contra um oponente até 2 quadrados de distância. Marca o oponente, durante 2 rodadas o alvo pode atacar Apenas esse personagem e vice- versa. Ambos não podem utilizar habilidades durante 2 rodadas.'
      },

      {
        name: 'Corte Duplo',
        cost: 2,
        type: 'atk',
        desc: 'Realiza um ataque adicional com dano reduzido pela metade.'
      },

      {
        name: 'Coragem Suprema',
        cost: 'all',
        type: 'sup',
        desc: 'Invoca uma aura que dura 3 rodadas: Dano e Defesa + 5, Mov + 2.'
      }
    ]
  },

  {
    name: 'Arqueiro',
    slug: 'arqueiro',
    primary: 'dex',
    secondary: 'str',
    pv: 12,
    ph: 6,
    str: 8,
    res: 6,
    dex: [10, 2],
    agi: 10,
    wis: 6,
    int: [8, 2],
    skills: [
      {
        name: 'Tiro Preciso',
        cost: 1,
        type: 'atk',
        desc: 'Alcance + 1, Dano + 1.'
      },

      {
        name: 'Tiro de Defesa',
        cost: 2,
        type: 'atk',
        desc: 'Dano + 2 e volta 2 quadrados para trás.'
      },

      {
        name: 'Tiro Duplo',
        cost: 2,
        type: 'atk',
        desc: 'Realiza um ataque adicional com dano reduzido pela metade.'
      },

      {
        name: 'Chuva de Flechas',
        cost: 'all',
        type: 'atk',
        desc:
          'Todos personagens em uma área de 7x7 - com o centro sendo esse personagem - são afetados. Dano + 3.'
      }
    ]
  },

  {
    name: 'Clérigo',
    slug: 'clerigo',
    primary: 'wis',
    secondary: 'str',
    pv: [12, 2],
    ph: [8, 2],
    str: [8, 2],
    res: 10,
    dex: 6,
    agi: 6,
    wis: [10, 2],
    int: 8,
    skills: [
      {
        name: 'Toque de Cura',
        cost: 2,
        type: 'sup',
        desc:
          'Recupera 5 pontos de PV desse personagem ou de um personagem adjacente.'
      },

      {
        name: 'Abençoar Armadura',
        cost: 2,
        type: 'sup',
        desc:
          'Defesa + 2 por 2 rodadas desse personagem ou de um personagem adjacente.'
      },

      {
        name: 'Abençoar Arma',
        cost: 2,
        type: 'sup',
        desc:
          'Dano + 3 por duas rodadas desse personagem ou de um personagem adjacente.'
      },

      {
        name: 'Invocar Divindade',
        cost: 'all',
        type: 'sup',
        desc:
          'Afeta todos personagens em uma área de 5x5 - sendo o centro esse personagem - paralisa todos personagens por uma rodada e recupera todo o PV desse personagem.'
      }
    ]
  },

  {
    name: 'Juiz',
    slug: 'juiz',
    primary: 'wis',
    secondary: 'str',
    pv: 12,
    ph: [8, 2],
    str: [8, 2],
    res: [10, 2],
    dex: 6,
    agi: 6,
    wis: 10,
    int: 8,
    skills: [
      {
        name: 'Deprezo pelos Condenados',
        cost: 2,
        type: 'atk',
        desc: 'Dano + 2.'
      },

      {
        name: 'Julgar o Mau',
        cost: 2,
        type: 'atk',
        desc:
          'Dano + 2 e joga 1d6, se o resultado for entre 2 e 5: o alvo não pode se movimentar no próximo turno e se o resultado for 1 ou 6: o alvo fica sangrando por 1 rodada.'
      },

      {
        name: 'Justiça Cega',
        cost: 3,
        type: 'sup',
        desc:
          'Pode ser ativada contra um oponente até 2 quadrados de distância. Durante 2 rodadas o oponente: Dano e Defesa - 2 e esse personagem: Dano e Defesa + 2.'
      },

      {
        name: 'Julgamento Final',
        cost: 'all',
        type: 'atk',
        desc:
          'Afeta uma área de 5x5 - com o centro sendo esse personagem - todos os personagens nessa área têm os atributos reduzidos em 3 pontos por 2 rodadas. Joga 1d6, se o resultado for um número par: todos personagens afetados ficam paralisados por 1 rodada, se o resultado for um número ímpar: todos personagens afetados ficam sangrando por 1 rodada.'
      }
    ]
  },

  {
    name: 'General',
    slug: 'general',
    primary: 'str',
    secondary: 'wis',
    pv: [18, 3],
    ph: 6,
    str: [10, 2],
    res: [8, 2],
    dex: 6,
    agi: 6,
    wis: 8,
    int: 10,
    skills: [
      {
        name: 'Marcar Aliado',
        cost: 2,
        type: 'sup',
        desc:
          'Pode ser ativada em um personagem até 3 quadrados de distância. Marca o personagem como aliado (personagens marcados como aliados não podem ser atacados nem atacar esse personagem) por 3 rodadas.'
      },

      {
        name: 'Chamar Equipe',
        cost: 2,
        type: 'sup',
        desc:
          'Teletransporta um aliado para um quadrado adjacente. Defesa + 1 por 2 rodadas.'
      },

      {
        name: 'Táticas de Combate',
        cost: 2,
        type: 'sup',
        desc:
          'Só pode ser ativado quando um aliado está em um quadrado adjacente. Aumenta todos os atributos próprios e do(s) aliado(s) adjacente(s) em 3 pontos.'
      },

      {
        name: 'Comando de Aço',
        cost: 'all',
        type: 'atk',
        desc:
          'Se um ou mais aliados estiverem adjacentes ao inimigo atacado, ele(s) também realiza(m) um ataque com: Dano + 3.'
      }
    ]
  },

  {
    name: 'Assassino',
    slug: 'assassino',
    primary: 'dex',
    secondary: 'str',
    pv: [12, 2],
    ph: 6,
    str: [8, 2],
    res: 6,
    dex: [10, 2],
    agi: 10,
    wis: 6,
    int: 8,
    skills: [
      {
        name: 'Corte Venenoso',
        cost: 2,
        type: 'atk',
        desc:
          'Dano + 1, joga 1d6, se o resultado for 1 ou 6 envenena o alvo por 1 rodada.'
      },

      {
        name: 'Desaparecer',
        cost: 2,
        type: 'sup',
        desc:
          'Muda o clima para “Neblina” por 2 rodadas e joga 1d6, se o resultado for 5 ou 6 fica invisível por 1 rodada.'
      },

      {
        name: 'Corte Relâmpago',
        cost: 2,
        type: 'atk',
        desc:
          'Pode ser ativada em um personagem até 3 quadrados de distância. Dano + 3 e joga 1d6, se o resultado for um número par o alvo fica sangrando por 2 rodadas.'
      },

      {
        name: 'Morte Silenciosa',
        cost: 'all',
        type: 'atk',
        desc:
          'Gasta todos os PHs. Pode ser ativada em um personagem até 3 quadrados de distância. Se o horário for noite, o clima neblina ou o terreno floresta joga 1d6, se o resultado for entre 1 e 5 o alvo fica sangrando pelo resto da batalha e se o resultado for 6 mata o alvo instantaneamente e esse personagem perde metade dos pontos de PV arredondado para baixo.'
      }
    ]
  },

  {
    name: 'Xamã',
    slug: 'xama',
    primary: 'wis',
    secondary: 'dex',
    pv: 8,
    ph: [8, 2],
    str: 6,
    res: 6,
    dex: [8, 2],
    agi: 8,
    wis: [10, 2],
    int: 10,
    skills: [
      {
        name: 'Gaohl',
        cost: 2,
        type: 'sup',
        desc:
          'Invoca um espírito de um antigo andarilho. Dura 2 rodadas: Mov + 1 e Defesa + 1.'
      },

      {
        name: 'Minwo',
        cost: 2,
        type: 'sup',
        desc:
          'Invoca um espírito de um antigo guerreiro. Dura 2 rodadas: Dano + 2 e Alcance + 1.'
      },

      {
        name: "Shen'z",
        cost: 2,
        type: 'sup',
        desc:
          'Invoca o espírito de um antigo arqueiro. Dura 2 rodadas: Dano + 2 e Alcance + 2.'
      },

      {
        name: 'Lyrueh',
        cost: 'all',
        type: 'sup',
        desc:
          'Invoca o espírito de um grande Demônio. Dura 2 rodadas: Dano + 7, Alcance + 1 e toda vez que ataca: Joga 1d6, se o resultado for 5 ou 6 paralisa o alvo por 1 rodada.'
      }
    ]
  },

  {
    name: 'Mímico',
    slug: 'mimico',
    primary: '',
    secondary: '',
    pv: 0,
    ph: 0,
    str: 0,
    res: 0,
    dex: 0,
    agi: 0,
    wis: 0,
    int: 0,
    skills: [
      {
        name: 'Cópia Perfeita',
        cost: 0,
        type: 'sup',
        desc:
          'Não gasta nenhum PH e pode ser usado uma vez a cada 2 rodadas. O Mímico copia a classe de um personagem do campo de batalha, copiando todas as mudanças de atributos, habilidade de classe, arma, armadura e acessório.'
      }
    ]
  }
]

export const classLevels = [
  {
    name: 'Aprendiz',
    value: 1,
    pv: -2,
    ph: -1,
    mov: -1,
    str: -1,
    res: -1,
    dex: -1,
    agi: -1,
    wis: -1,
    int: -1
  },

  {
    name: 'Normal',
    value: 2,
    pv: 0,
    ph: 0,
    mov: 0,
    str: 0,
    res: 0,
    dex: 0,
    agi: 0,
    wis: 0,
    int: 0
  },

  {
    name: 'Normal',
    value: 2,
    pv: 0,
    ph: 0,
    mov: 0,
    str: 0,
    res: 0,
    dex: 0,
    agi: 0,
    wis: 0,
    int: 0
  },

  {
    name: 'Normal',
    value: 2,
    pv: 0,
    ph: 0,
    mov: 0,
    str: 0,
    res: 0,
    dex: 0,
    agi: 0,
    wis: 0,
    int: 0
  },

  {
    name: 'Veterano',
    value: 3,
    pv: 2,
    ph: 1,
    mov: 1,
    str: 1,
    res: 1,
    dex: 1,
    agi: 1,
    wis: 1,
    int: 1
  },

  {
    name: 'Lendário',
    value: 4,
    pv: 5,
    ph: 2,
    mov: 3,
    str: 3,
    res: 3,
    dex: 3,
    agi: 3,
    wis: 3,
    int: 3
  }
]
